import { defineNuxtPlugin } from '#app/nuxt'
import { LazyGlobalEnvTag, LazyGlobalPageBanner, LazyGlobalPageBannerContent, LazySiteVersionCheck, LazyGlobalAlertNotification } from '#components'
const lazyGlobalComponents = [
  ["GlobalEnvTag", LazyGlobalEnvTag],
["GlobalPageBanner", LazyGlobalPageBanner],
["GlobalPageBannerContent", LazyGlobalPageBannerContent],
["SiteVersionCheck", LazySiteVersionCheck],
["GlobalAlertNotification", LazyGlobalAlertNotification],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
